import { Stack } from "@mui/material";
import { ReactGrid } from "@silevis/reactgrid";
import type { FC, Ref } from "react";
import { memo } from "react";
import CombinationResources from "./CombinationResources";
import { getReadonlyRoomsCells } from "./getReadonlyRoomsCells";
import type { ParticipantListCombinationResponse, ParticipantListRequiredFields } from "./participantListApi";
import { useColumns } from "./useColumns";

interface Props {
  readonly combination: ParticipantListCombinationResponse;
  readonly previousCombination: ParticipantListCombinationResponse | undefined;
  readonly requiredFields: ParticipantListRequiredFields;
  readonly showDiffs: boolean;
}

const ReadonlyParticipantListCombination: FC<Props> = ({
  combination,
  previousCombination,
  requiredFields,
  showDiffs,
}) => {
  const { ref, columns, handleResizeColumn } = useColumns(requiredFields);
  const cells = getReadonlyRoomsCells(combination, previousCombination, requiredFields, showDiffs);
  const rooms = Object.entries(combination).map(([, { rooms, resources }]) => ({
    rooms,
    resources,
    count: rooms.length,
  }));

  return (
    <Stack direction="column" spacing={2} ref={ref as Ref<HTMLDivElement>}>
      <CombinationResources rooms={rooms} />
      <ReactGrid
        columns={columns}
        cells={cells}
        stickyTopRows={1}
        stickyLeftColumns={2}
        initialFocusLocation={{ rowIndex: 1, colIndex: 2 }}
        onResizeColumn={handleResizeColumn}
      />
    </Stack>
  );
};

export default memo(ReadonlyParticipantListCombination);
